"use client";

import * as React from "react";
import { useSearchParams } from "next/navigation";

interface SearchParamsContextType {
  searchParams: URLSearchParams | null;
}

const SearchParamsContext = React.createContext<SearchParamsContextType>({
  searchParams: null,
});

function SearchParamsComponent({ children }: { children: React.ReactNode }) {
  const searchParams = useSearchParams();
  
  return (
    <SearchParamsContext.Provider value={{ searchParams }}>
      {children}
    </SearchParamsContext.Provider>
  );
}

export function SearchParamsProvider({ children }: { children: React.ReactNode }) {
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <SearchParamsComponent>{children}</SearchParamsComponent>
    </React.Suspense>
  );
}

export function useSearchParamsWrapper() {
  const context = React.useContext(SearchParamsContext);
  return context.searchParams;
}